export const enum LandingPagesRoutesEnum {
  home = '/',
  forSite = '/for-site',
  forOffice = '/for-office',
  privacyPolicy = '/privacy-policy'
}